import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import { Small } from 'foundations-components/transitional/components/Small';
import { RemovalModal, HasReferencesModal, RemoveFormWorkflowDependencyButton } from 'ContentComponents/components/cmv2/form/formAutomation/connectedWorkflows/RemoveFormWorkflowDependencyButton';
import WorkflowLink from 'ContentComponents/components/cmv2/form/formAutomation/connectedWorkflows/WorkflowLink';
import { fetchWorkflowReferences } from 'ContentData/api/Workflows';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.${key}`;
const FormWorkflowDependenciesTableRow = ({
  contentId,
  formGuid,
  formWorkflowDependency,
  hasWorkflowsAppAccess,
  hasWorkflowsDeleteAccess,
  onEditWorkflowEvent,
  onRemoveWorkflowEvent,
  readOnly
}) => {
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [isHasReferencesModalOpen, setIsHasReferencesModalOpen] = useState(false);
  const onWorkflowLinkClick = () => {
    if (onEditWorkflowEvent) onEditWorkflowEvent();
  };
  const closeRemoveModal = () => {
    setIsRemoveModalOpen(false);
  };
  const closeHasReferencesModal = () => {
    setIsHasReferencesModalOpen(false);
  };
  const {
    canDelete,
    flowId,
    name
  } = formWorkflowDependency;
  const onRemoveWorkflowClick = () => {
    if (canDelete) {
      fetchWorkflowReferences(flowId).then(response => {
        const {
          flowReferences
        } = response || {};
        if (flowReferences && flowReferences.length) {
          setIsHasReferencesModalOpen(true);
        } else {
          setIsRemoveModalOpen(true);
        }
      }).catch(() => {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('deleteWorkflowModal.deleteError'),
            options: {
              workflowName: name
            }
          }),
          type: 'danger'
        });
      });
    } else {
      setIsRemoveModalOpen(true);
    }
  };
  let actions;
  if (contentId && !readOnly) {
    actions = /*#__PURE__*/_jsx(RemoveFormWorkflowDependencyButton, {
      formGuid: formGuid,
      formWorkflowDependency: formWorkflowDependency,
      hasWorkflowsDeleteAccess: hasWorkflowsDeleteAccess,
      onClick: onRemoveWorkflowClick
    });
  }
  return /*#__PURE__*/_jsxs("tr", {
    children: [isRemoveModalOpen && /*#__PURE__*/_jsx(RemovalModal, {
      contentId: contentId,
      formGuid: formGuid,
      formWorkflowDependency: formWorkflowDependency,
      onClose: closeRemoveModal,
      onRemoveWorkflowEvent: onRemoveWorkflowEvent,
      workflowLink: /*#__PURE__*/_jsx(WorkflowLink, {
        formGuid: formGuid,
        formWorkflowDependency: formWorkflowDependency,
        hasWorkflowsAppAccess: hasWorkflowsAppAccess
      })
    }), isHasReferencesModalOpen && /*#__PURE__*/_jsx(HasReferencesModal, {
      onClose: closeHasReferencesModal,
      workflowLink: /*#__PURE__*/_jsx(WorkflowLink, {
        formGuid: formGuid,
        formWorkflowDependency: formWorkflowDependency,
        hasWorkflowsAppAccess: hasWorkflowsAppAccess
      }),
      workflowName: name
    }), /*#__PURE__*/_jsx(TableHoverCell, {
      hoverContent: actions,
      tooltip: formWorkflowDependency.name,
      padding: "400",
      children: /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(WorkflowLink, {
          "data-selenium": "form-field-workflow-dependencies-workflow-link",
          formGuid: formGuid,
          formWorkflowDependency: formWorkflowDependency,
          hasWorkflowsAppAccess: hasWorkflowsAppAccess,
          onClick: onWorkflowLinkClick,
          truncate: true
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: i18nKey('dependencyRow.lastUpdated'),
            options: {
              timestamp: /*#__PURE__*/_jsx(FormattedDateTime, {
                value: formWorkflowDependency.updateMetadata.updatedAt,
                format: "lll"
              })
            }
          })
        })]
      })
    })]
  });
};
export default FormWorkflowDependenciesTableRow;